export enum EventAction {
  SUBMIT = 'Submit',
  REQUEST = 'Request',
  ZIP_DOWNLOAD = 'Zip Download',
  MAP_BROWSING = 'Map Browsing',
  MAP_INTERACTION = 'Map Interaction',
  BROWSING = 'Browsing',
  DOWNLOAD = 'Download',
}
